var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKsw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.6667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16338 32 0 24.8366 0 16C0 7.16338 7.16338 0 16 0C24.8366 0 32 7.16338 32 16ZM18.0073 17.3433C18.7685 19.3138 19.1291 23.2558 19.2238 24.4601C19.24 24.6684 19.408 24.8311 19.6181 24.8459C25.8135 25.2718 27.2386 22.4185 27.5353 21.5031C27.5868 21.3419 27.5381 21.1671 27.408 21.0569C24.9451 18.9764 21.8101 17.2224 20.7913 16.6754C20.626 16.5867 20.4201 16.6135 20.2914 16.7479C20.053 16.9966 19.4894 17.338 18.197 17.3003H17.9842L18.0073 17.3433ZM16.5644 11.853C18.5993 12.4619 19.4027 13.3019 19.6276 13.5881C19.675 13.6473 19.7508 13.6715 19.824 13.6512C21.4645 13.1675 23.5212 12.7897 24.3232 12.6514C24.4681 12.6258 24.525 12.4484 24.422 12.3449C20.6057 8.51698 16.2053 7.37049 14.9915 7.1152C14.8507 7.08551 14.7314 7.22276 14.7829 7.35716L16.4452 11.7428C16.4654 11.7964 16.5102 11.8368 16.5644 11.853ZM13.3659 12.7467C13.294 13.795 13.63 14.5867 13.8752 15.0155C13.9849 15.2076 13.8928 15.4496 13.6828 15.5221C12.4094 15.9589 8.6688 17.2654 7.12569 18.0718C6.96587 18.1552 6.77084 18.1095 6.66791 17.963C5.87929 16.846 3.0032 12.3596 5.34418 9.35698C5.43911 9.23609 5.60018 9.18773 5.74524 9.23876C6.72747 9.58418 10.5723 10.9806 13.1735 12.5276C13.1991 12.5424 13.2222 12.5612 13.2439 12.5813L13.336 12.6727L13.3659 12.7467ZM17.8356 13.2704C18.9333 14.022 19.4741 15.1337 19.0432 15.7532C18.6123 16.3726 17.3728 16.2654 16.2748 15.5136C15.1769 14.762 14.6363 13.6503 15.0672 13.0308C15.4981 12.4114 16.7376 12.5186 17.8356 13.2704Z",
    fill: "#182779"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsw);
export default __webpack_public_path__ + "static/media/ksw.7513952938c22b68f7214bed8da20062.svg";
export { ForwardRef as ReactComponent };